/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import BreadcrumbInfo from 'Docs/uilib/components/breadcrumb/info';
import BreadcrumbDemos from 'Docs/uilib/components/breadcrumb/demos';
function _createMdxContent(props) {
  return _jsxs(_Fragment, {
    children: [_jsx(BreadcrumbInfo, {}), "\n", _jsx(BreadcrumbDemos, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
